import React from "react";

type Props = {
  showHrZones: boolean;
};

export default function SummaryTableHeader({ showHrZones }: Props) {
  return (
    <thead>
      <tr>
        <th>Tydzień</th>
        <th>Czas</th>
        <th>Dyst/Przew</th>
        <th>Domeny</th>
        <th style={{ minWidth: showHrZones ? 180 : 260 }}>
          {showHrZones ? "Strefy HR" : "Stats"}
        </th>
      </tr>
    </thead>
  );
}